module.exports = __webpack_public_path__ + "static/media/info.3d0b0551.svg";